import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Google Ads Etiketini Dinamik Yükleme
(function loadGoogleTag() {
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=AW-16782945974";
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "AW-16782945974");
  };
})();

ReactDOM.render(<App />, document.getElementById("root"));
